import React, { ReactElement } from "react";
import { IconProps } from "../Icon.types";

const AlertOctagonIcon = ({
  size = "1em",
  fill = "#343A40",
  title = "",
  iconClass = "",
  className,
  ...props
}: IconProps): ReactElement => {
  return (
    <svg
      {...props}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      version="1.1"
      className={className || iconClass}
    >
      <title>{title}</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill={fill}>
          <path d="M8.27421356,3 L3,8.27421356 L3,15.7257864 L8.27421356,21 L15.7257864,21 L21,15.7257864 L21,8.27421356 L15.7257864,3 L8.27421356,3 Z M16.14,1 C16.4052165,1 16.6595704,1.10535684 16.8471068,1.29289322 L22.7071068,7.15289322 C22.8946432,7.3404296 23,7.59478351 23,7.86 L23,16.14 C23,16.4052165 22.8946432,16.6595704 22.7071068,16.8471068 L16.8471068,22.7071068 C16.6595704,22.8946432 16.4052165,23 16.14,23 L7.86,23 C7.59478351,23 7.3404296,22.8946432 7.15289322,22.7071068 L1.29289322,16.8471068 C1.10535684,16.6595704 1,16.4052165 1,16.14 L1,7.86 C1,7.59478351 1.10535684,7.3404296 1.29289322,7.15289322 L7.15289322,1.29289322 C7.3404296,1.10535684 7.59478351,1 7.86,1 L16.14,1 Z M12,15 C11.4477153,15 11,15.4477153 11,16 C11,16.5522847 11.4477153,17 12,17 C12.5522847,17 13,16.5522847 13,16 C13,15.4477153 12.5522847,15 12,15 Z M12,7 C11.4477153,7 11,7.44771525 11,8 L11,8 L11,12 C11,12.5522847 11.4477153,13 12,13 C12.5522847,13 13,12.5522847 13,12 L13,12 L13,8 C13,7.44771525 12.5522847,7 12,7 Z" />
        </g>
      </g>
    </svg>
  );
};

export { AlertOctagonIcon };
